<template>
  <find-dialog v-if="showDialog" @emitSelect="wholesalerSelect" @emitClose="closeDialog" />
</template>

<script>
import FindDialog from '@/components/wholesaler/FindDialog.vue'
import { mapState } from 'vuex'
export default {
  components: { FindDialog },
  computed: {
    ...mapState('bnpl', ['payments']),
  },
  data() {
    return {
      showDialog: true,
    }
  },
  methods: {
    filterPaymentsStatus(status, wholesaler) {
      return this.payments.results.filter(
        (p) =>
          [status].includes(p.status) && p.wholesalerAccount.wholesaler.uuid === wholesaler.uuid,
      )
    },
    async wholesalerSelect(wholesaler) {
      //입금대기?
      const inProgresses = this.filterPaymentsStatus('in_progress', wholesaler)
      if (inProgresses.length > 0) {
        // this.$swal.basic
        const { isConfirmed } = await this.$swal.basic.confirm({
          html: `해당 거래처가 입금 중 목록에 있습니다.</br> 추가 하시겠습니까?`,
        })
        if (isConfirmed === false) {
          return
        }
      }

      this.$router.push(`/payments/form?wholesalerId=${wholesaler.uuid}`)
    },
    closeDialog(result) {
      setTimeout(() => {
        this.$router.go(-1)
      }, 50)
    },
  },
}
</script>

<style></style>
